<template>
  <v-card outlined>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels
            :value="expansionPanelsQueDevemAbrirPorDefault"
            multiple
            focusable
            class="mt-3"
          >
            <secao-default-dados-agendamento-expansion-panel
              :ticket-id="ticketSelecionadoId"
              :solicitante-primeiro-endereco-cadastrado="solicitantePrimeiroEnderecoCadastrado"
              :agendamento-selecionado="agendamentoSelecionado"
              @refetch-data="handleRefetchData"
            />
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h3 class="mb-4">
            Agendamentos
          </h3>

          <agendamento-table
            :agendamentos="agendamentos"
            @selecionar-agendamento="v => agendamentoSelecionado = v"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import SecaoDefaultDadosAgendamentoExpansionPanel from './SecaoDefaultDadosAgendamentoExpansionPanel.vue'
import AgendamentoTable from './AgendamentoTable.vue'
import TicketService from '@/services/modules/TicketService'
import useAtendimentoStore from '@/store/atendimento'
import useAtendimentoTicket from '@/composables/useAtendimentoTicket'

export default {
  components: {
    SecaoDefaultDadosAgendamentoExpansionPanel,
    AgendamentoTable,
  },

  setup() {
    const { ticketSelecionadoId } = storeToRefs(useAtendimentoStore())
    const { ticketEstaFinalizado } = useAtendimentoTicket(ticketSelecionadoId)
    const expansionPanelsQueDevemAbrirPorDefault = ref([0])

    const agendamentos = ref([])
    const agendamentoSelecionado = ref(null)
    const solicitantePrimeiroEnderecoCadastrado = ref(null)

    async function getTicketById() {
      const data = await TicketService.getTicketById(ticketSelecionadoId.value)
      const [endereco] = data.solicitante.enderecos

      solicitantePrimeiroEnderecoCadastrado.value = endereco
    }

    async function getAgendamentos() {
      agendamentos.value = await TicketService.getTicketAgendamentos(ticketSelecionadoId.value)
    }

    async function getData() {
      await getTicketById()
      await getAgendamentos()
    }

    watch(
      ticketSelecionadoId,
      getData,
      { immediate: true },
    )

    async function handleRefetchData() {
      agendamentoSelecionado.value = null
      await getAgendamentos()
    }

    return {
      ticketSelecionadoId,
      ticketEstaFinalizado,
      expansionPanelsQueDevemAbrirPorDefault,
      agendamentos,
      agendamentoSelecionado,
      solicitantePrimeiroEnderecoCadastrado,
      handleRefetchData,
    }
  },
}
</script>
